import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useAuthStore from "store/authStore";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useFetchSubscriptionBenefits = ({ enabled = true } = {}) => {
	const { loggedIn } = useAuthStore();
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		if (!loggedIn) {
			return { data: { benefits: [] } };
		}
		const instance = await InitApi({ accessToken });
		const res = await instance.get("subscription-benefits");
		return res?.data;
	};

	return useQuery(["subscription-benefits"], () => fetch(), {
		...fetchConfig,
		enabled: Boolean(loggedIn) && enabled,
	});
};

export default useFetchSubscriptionBenefits;
